"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasChartBeenInitialized = void 0;
var carbonPrefix = 'bx';
var chartsPrefix = 'cc';
var hasChartBeenInitialized = function (chartHolder) {
    return !!chartHolder.querySelector("div." + carbonPrefix + "--" + chartsPrefix + "--chart-wrapper");
};
exports.hasChartBeenInitialized = hasChartBeenInitialized;
